"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function band(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M13.6796 9.37805L15.3296 10.3208V5.6063L12.0296 3.9563L6.90262 6.8438V17.097L12.0296 20.0438L17.0974 17.0386V11.9708L12.2059 9.02405L10.5559 9.84905L15.4474 12.7366L15.5059 16.2136L12.0296 18.1583L8.49337 16.1543V7.6688L12.0296 5.72405L13.6796 6.6083V9.37805Z", fill: color }),
        React.createElement("path", { d: "M11.8526 12.2063L12.9724 11.6168L14.2099 12.3833L10.5559 14.4458V10.2031L11.8526 10.9688", fill: color }));
}
exports["default"] = band;
//# sourceMappingURL=band.js.map